import { repository } from '@/api/base'

export default {
    async getAllPair() {
        const { data } = await repository.get(`/dictionary/pairTime`)
        return data
    },
    async createPair(pair) {
        const { data } = await repository.post(`/dictionary/pairTime`, pair)
        return data
    },
    async editPair (pair) {
        const { data } = await repository.put(`/dictionary/pairTime`, pair)
        return data
    },
    async getPair (pairId) {
        const { data } = await repository.get(`/dictionary/pairTime/${pairId}`)
        return data
    },
    async deletePair (pairId) {
        const { data } = await repository.delete(`/dictionary/pairTime/${pairId}`)
        return data
    }
}